var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplePay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.594.285H8.221A7.895 7.895 0 0 0 .326 8.18v26.318a7.895 7.895 0 0 0 7.895 7.895h47.373a7.895 7.895 0 0 0 7.895-7.895V8.18A7.895 7.895 0 0 0 55.594.285z",
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.802 13.694c.571-.715.96-1.675.857-2.656-.837.04-1.859.552-2.45 1.268-.531.613-1.001 1.613-.878 2.553.94.082 1.879-.47 2.471-1.165zm.846 1.349c-1.364-.081-2.525.775-3.176.775-.652 0-1.65-.734-2.73-.714-1.404.02-2.708.815-3.42 2.078-1.467 2.527-.388 6.276 1.038 8.334.693 1.019 1.527 2.14 2.627 2.1 1.039-.041 1.446-.673 2.709-.673 1.262 0 1.629.673 2.728.652 1.14-.02 1.854-1.02 2.546-2.038.795-1.16 1.12-2.282 1.14-2.343-.02-.02-2.199-.856-2.22-3.362-.02-2.1 1.711-3.097 1.793-3.16-.978-1.445-2.505-1.608-3.035-1.65zm11.882-2.84c2.966 0 5.032 2.045 5.032 5.02 0 2.988-2.108 5.044-5.106 5.044h-3.284v5.222H23.8V12.203h5.73zm-3.358 8.072h2.723c2.065 0 3.241-1.112 3.241-3.04s-1.176-3.03-3.23-3.03h-2.734v6.07zm9.01 4.046c0-1.95 1.493-3.146 4.142-3.294l3.05-.18v-.858c0-1.24-.837-1.981-2.235-1.981-1.324 0-2.15.636-2.351 1.63h-2.161c.127-2.011 1.843-3.494 4.597-3.494 2.701 0 4.428 1.43 4.428 3.665v7.68h-2.193v-1.833h-.053c-.646 1.24-2.055 2.023-3.517 2.023-2.182 0-3.707-1.356-3.707-3.358zm7.192-1.006v-.88l-2.743.17c-1.367.096-2.14.7-2.14 1.653 0 .974.805 1.61 2.034 1.61 1.6 0 2.849-1.102 2.849-2.553zm4.348 8.274v-1.854c.169.042.55.042.741.042 1.06 0 1.631-.445 1.98-1.59 0-.02.202-.677.202-.687L45.62 16.345h2.48l2.818 9.068h.042l2.818-9.068h2.415l-4.174 11.727c-.953 2.7-2.055 3.57-4.364 3.57-.19 0-.764-.022-.933-.053z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.593 1.162H8.221A7.018 7.018 0 0 0 1.203 8.18v26.318a7.018 7.018 0 0 0 7.018 7.018h47.372a7.018 7.018 0 0 0 7.018-7.018V8.18a7.018 7.018 0 0 0-7.018-7.018z",
    stroke: "url(#c)",
    strokeWidth: 1.755
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.66636 25.8986 -39.17583 -4.0333 44.899 15.565)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#ECC5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#EDB7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E99999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#E66F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#E74141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E81515"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v43H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: -50,
    y: -50,
    width: 164,
    height: 143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_428_321"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_428_321",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplePay);
export default __webpack_public_path__ + "static/media/apple-pay.4839d5e9d3202aaf823ba10df90c15f6.svg";
export { ForwardRef as ReactComponent };